var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewObjectPassive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.833 7.833H6.167a.504.504 0 0 1-.5-.5c0-.273.226-.5.5-.5h3.666c.274 0 .5.227.5.5 0 .274-.226.5-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9.667a.504.504 0 0 1-.5-.5V5.5c0-.273.227-.5.5-.5s.5.227.5.5v3.667c0 .273-.227.5-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15.173a3.98 3.98 0 0 1-2.753-1.113c-1.967-1.893-4.14-4.913-3.32-8.507C2.667 2.293 5.513.833 8 .833h.007c2.486 0 5.333 1.46 6.073 4.727.813 3.593-1.36 6.607-3.327 8.5A3.98 3.98 0 0 1 8 15.173m0-13.34c-1.94 0-4.433 1.034-5.093 3.94-.72 3.14 1.253 5.847 3.04 7.56a2.95 2.95 0 0 0 4.113 0c1.78-1.713 3.753-4.42 3.047-7.56C12.44 2.867 9.94 1.833 8 1.833"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewObjectPassive);
export default __webpack_public_path__ + "static/media/newObjectPassive.0d459c366f637d1139301e7d586eebe4.svg";
export { ForwardRef as ReactComponent };